
// Production environment debugging utility
export const debugEnvironment = () => {
  const isProduction = window.location.hostname === 'snaprefund.com';
  const isLovableStaging = window.location.hostname.includes('lovableproject.com');
  const isLocalhost = window.location.hostname === 'localhost';
  
  console.log('🌍 Environment Debug:', {
    hostname: window.location.hostname,
    isProduction,
    isLovableStaging,
    isLocalhost,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString()
  });
  
  // Check for any cached values that might be interfering
  const localStorageKeys = Object.keys(localStorage);
  const sessionStorageKeys = Object.keys(sessionStorage);
  
  console.log('🗄️ Storage Debug:', {
    localStorageKeys,
    sessionStorageKeys,
    localStorageSize: localStorageKeys.length,
    sessionStorageSize: sessionStorageKeys.length
  });
  
  // Check for any relevant cached values
  const relevantKeys = localStorageKeys.filter(key => 
    key.includes('format') || 
    key.includes('message') || 
    key.includes('conversation') ||
    key.includes('refund')
  );
  
  if (relevantKeys.length > 0) {
    console.log('🔍 Potentially Relevant Cached Data:', 
      relevantKeys.reduce((acc, key) => {
        acc[key] = localStorage.getItem(key);
        return acc;
      }, {} as Record<string, string | null>)
    );
  }
  
  return {
    isProduction,
    isLovableStaging,
    isLocalhost,
    environment: isProduction ? 'production' : isLovableStaging ? 'staging' : 'localhost'
  };
};

// Add to window for manual debugging
if (typeof window !== 'undefined') {
  (window as any).debugEnvironment = debugEnvironment;
}
